import {
  PROCEDURE_STATUSES,
  PROCEDURE_STEPS,
  REJECTION_REASON,
} from 'containers/data-structure';
import { get, isEmpty } from 'lodash';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import { STATUS_REJECTED } from 'containers/LawyerFeeNote/constants';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import { formatCourtFileNumber } from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import { IJudgementAdd } from 'containers/LawyerLegalProceedingsPage/typings';

export const activateDecisionButton = (
  judgementAddDocument: JudgementADDDocumentType,
  isManager: boolean,
) => {
  return (
    ((!isEmpty(get(judgementAddDocument, 'status', '')) &&
      featureService.hasFeature(FEATURES.ADD_MULTIPLE_JUDGEMENT_ADD) &&
      !get(judgementAddDocument, 'byManager', false)) ||
      (get(judgementAddDocument, 'status', '') ===
        PROCEDURE_STATUSES.REJECTED &&
        featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER))) &&
    isManager
  );
};

export const showmultipleJADDDecision = (
  judgementAddDocument: JudgementADDDocumentType,
) =>
  !isEmpty(get(judgementAddDocument, 'status', '')) &&
  get(judgementAddDocument, 'status', '') !== PROCEDURE_STATUSES.PENDING &&
  featureService.hasFeature(FEATURES.ADD_MULTIPLE_JUDGEMENT_ADD);

export const validateAfterRejection = (
  judgementAddDocument: JudgementADDDocumentType,
) => {
  return (
    get(judgementAddDocument, 'status') === STATUS_REJECTED &&
    featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER)
  );
};
export const showJADDDecision = (
  judgementAdd: any,
  judgementAddDocument: JudgementADDDocumentType,
) =>
  isEmpty(get(judgementAddDocument, 'status')) &&
  (get(judgementAdd, 'status', '') === PROCEDURE_STATUSES.VALIDATED ||
    get(judgementAdd, 'status', '') === PROCEDURE_STATUSES.TO_EDIT);

export const formatFeeNoteToGenerate = (
  judgementAddDocument: JudgementADDDocumentType,
  lawyerFirmReference: string,
  claimNumber?: string,
  judgementAdd?: IJudgementAdd | {},
) => {
  return {
    step: PROCEDURE_STEPS.JUDGEMENT_ADD,
    codeIntervenant:
      currentIntervenantStorage.get() &&
      currentIntervenantStorage.get().sagis_code,
    judgementDate: get(judgementAddDocument, 'judgementDate', null),
    judgementAddDocumentId: get(judgementAddDocument, 'id', null),
    judgementId:
      get(judgementAddDocument, 'status') === ''
        ? get(judgementAdd, 'id')
        : undefined,
    firmReference: lawyerFirmReference,
    status:
      get(judgementAddDocument, 'status') === ''
        ? get(judgementAdd, 'status') === PROCEDURE_STATUSES.TO_EDIT
          ? PROCEDURE_STATUSES.REJECTED
          : PROCEDURE_STATUSES.PENDING
        : get(judgementAddDocument, 'status') === PROCEDURE_STATUSES.REJECTED
        ? PROCEDURE_STATUSES.REJECTED
        : PROCEDURE_STATUSES.PENDING,
    comment:
      get(judgementAddDocument, 'status') === ''
        ? get(judgementAdd, 'status') === PROCEDURE_STATUSES.TO_EDIT
          ? REJECTION_REASON
          : null
        : get(judgementAddDocument, 'status') === PROCEDURE_STATUSES.REJECTED
        ? REJECTION_REASON
        : null,
    claimNumber: claimNumber,
    courtNumber: formatCourtFileNumber(
      get(judgementAdd, 'judgementAdd.courtFile'),
    ),
  };
};
